module.exports = __webpack_public_path__ + "img/ryanne.254e9145.jpg";